module.exports = __webpack_public_path__ + "img/na.na7e46f9f.svg";